<section class="dash-page">
  <app-filter-dashboard [emitOnInit]="true" [showGranularity]="true" (changesDates)="changeDates($event)"/>

  <div class="dash-content col-12 pt-5">
    <div class="flex flex-column gap-2">
      <div>
        <CustomTitle [title]="translations.dashboard" [showTag]="false" styleClass="dash-title ml-2"/>
      </div>
      <div class="col-12">
        <div class="flex flex-wrap gap-3  ">
          @for (item of totalTramites(); track $index) {
            <app-tarjeta-kpi [data]="item" class="flex-1" style="min-width:180px"/>
          }
        </div>
      </div>

      <div class="col-12">
        <div class="dash-card h-full">
          <div class="dash-header">
            <div>
              <h2 class="dash-title">{{ lineConfig.title }}</h2>
            </div>
          </div>
          <div class="dash-body">
            <app-chart-line [config]="lineConfig.chart"/>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
